import React, { useState, useEffect, useContext, useRef } from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faUserCheck,
} from '@fortawesome/free-solid-svg-icons';
// import core components
import { domHelper, localstorageHelper } from 'helpers';
import { UserContext } from 'contexts';
import { cognitoService } from 'services';

import {
  Wrapper,
  CloseModalButton,
  SocialFieldSet,
  SocialField,
  LoginForm,
  FormTitle,
  NormalFieldSet,
  Field,
  Button,
  ButtonOutline,
  Subtitle,
  Section,
} from '../Login/styles';

// Import static icons
import CloseIcon from '/static/icons/controls/close.svg';
import GoogleIcon from '/static/icons/auth/google.svg';
import FacebookIcon from '/static/icons/auth/facebook.svg';
import AppleIcon from '/static/icons/auth/apple.svg';
import LoadingGif from '/static/gifs/loading.gif';
import PasswordIcon from '/static/icons/auth/password.svg';
import UserIcon from '/static/icons/auth/user.svg';
import { Auth } from 'aws-amplify';
import { socialProviders } from '../../constants';

const RegisterForm = styled(LoginForm)``;

const AcceptToS = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: ${props => props.theme.textSize.s};
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    margin-right: 10px;
    border-color: ${props => props.theme.colors.stroke};
  }
`;

const LegacyAccount = ({ data, setData, onClose, onLogin, onRegister, onForgotPassword }) => {

  return (
    <Wrapper>
      <CloseModalButton onClick={onClose}>
        <CloseIcon />
      </CloseModalButton>
        <FormTitle>
          My simplysay.sg account
        </FormTitle>
            <span>If you registered with simplysay.sg before <b>February 1st 2022</b>, then your account will have been migrated to our new website.</span>
            <br/><span>You have the following options:</span><br/>
            <span>
                <ul>
                    <li><b>Keep existing email login</b> - Reset your password, by going to <a href="" onClick={onLogin}>Sign In</a> and select Forgot Password. Make sure you submit the same email address that you registered with simplysay.sg</li>
                    <li><b>Switch to social network</b> - <a href="" onClick={onRegister}>Register</a> a new account by clicking one of the social networks (Google, Facebook, Apple), then contact our <a href="mailto:hello@simplysay.com">support team</a> and they will link your previous history.</li>
                </ul>
            </span>
            <span>For customers that have recently registered on our legacy website, you may contact our <a href="mailto:hello@simplysay.com">support team</a> and request a manual migration of your old account.</span>
            <br/>
    </Wrapper>
  );
};

export default LegacyAccount;
